<template>
  <div>
    <swiper :slidesPerView="4" :spaceBetween="12" :breakpoints="{
      320: {
        slidesPerView: 1,
        spaceBetween: 12,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 12,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 12,
      },
      1700: {
        slidesPerView: 4,
        spaceBetween: 12,
      },
    }" :centeredSlides="false" :modules="modules" class="mySwiper">
      <swiper-slide v-for="(img, index) in elements" :key="index" class="product product-7 text-center">
        <div :class="(category == 1 && img.company_id !== null) ||
            (category == 3 && img.company !== null)
            ? 'bg-light border border-2 border-danger rounded'
            : ''
          ">
          <figure class="product-media" :class="{ 'product-media-poster': category == 3 }">
            <div v-if="category == 1">
              <span class="product-label label-sale" v-if="img.new">Novita</span>
            </div>

            <a href="#" @click="getRedirectUrl(category, img.slug)">
              <div v-if="category == 1 || category == 3">
                <div v-if="img?.cover?.path">
                  <img :src="img?.cover?.path" alt="copertina post" class="img-thumbnail" />
                </div>
                <div v-else>
                  <img
                    src="https://storage.googleapis.com/neurohub-public-bucket/neurohub/public/assets/immagine_default.jpg"
                    alt="copertina post" class="img-thumbnail" />
                  <p>{{ img?.cover?.path }}</p>
                </div>
              </div>
              <div v-else>
                <div class="embed-responsive embed-responsive-16by9 center-block" style="display: flex;"
                  v-if="img?.cover?.type_file == 'pdf'">
                  <PdfPreview :src="img.cover.path" />
                </div>
                <img :src="img?.cover?.path" alt="Copertina biblioteca" class="product-image"
                  v-if="img?.cover?.type_file == 'jpg'" />
                <img :src="'https://storage.googleapis.com/neurohub-public-bucket/neurohub/public/assets/scrivi.jpg'"
                  alt="Copertina biblioteca" class="product-image" v-if="img?.cover == null" />

                <div v-if="
                  img?.cover?.type_file == 'm4v' ||
                  img?.cover?.type_file == 'mp4'
                ">
                  <video-component :options="getOptions(img?.cover?.path)"></video-component>
                </div>
              </div>
            </a>
          </figure>
          <!-- End .product-media -->

          <div class="product-body">
            <div class="product-cat">
              <a href="#" @click="getRedirectUrl(category, img.slug)" v-if="category == 1 || category == 2">
                Pubblicato da: {{ img.full_name }}
              </a>
              <a href="#" @click="getRedirectUrl(category, img.slug)" v-if="category == 3 || category == 4">
                Pubblicato da: {{ img.author }}
              </a>
            </div>
            <!-- End .product-cat -->
            <h3 class="product-title">
              <a href="#" @click="getRedirectUrl(category, img.slug)">
                {{ img.name }}</a>
              <p v-if="img.company" class="text-danger">
                Azienda promotrice: &nbsp;
                <strong>{{ img.company }}</strong>
              </p>
            </h3>
            <p v-if="category == 1">{{ img.short_description }}</p>
            <p v-if="category == 3">
              Data inizio meeting: {{ img.datetime_start }} <br />
              Data fine meeting: {{ img.datetime_end }}
            </p>
          </div>
          <!-- End .product-body -->
        </div>
        <!-- End .product -->
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import router from "@/router";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import VideoComponent from "./VideoComponent.vue";
import PdfPreview from "./PdfPreview.vue";

export default {
  name: "SwiperComponents",
  props: ["elements", "category"],
  components: {
    Swiper,
    SwiperSlide,
    VideoComponent,
    PdfPreview,
  },
  setup() {
    return {
      modules: [Pagination],
    };
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 6, // Numero di elementi da visualizzare nella stessa riga
        spaceBetween: 5, // Spazio tra gli elementi
      },
    };
  },
  mounted() { },
  created() { },
  methods: {
    getOptions(path) {
      return {
        controls: true,
        autoplay: false,
        fluid: true,
        // Puoi aggiungere ulteriori opzioni personalizzate qui

        // Esempio di configurazione del sorgente del video
        sources: [
          {
            src: path,
            type: "video/mp4",
          },
        ],
      };
    },
    getRedirectUrl(category, slug) {
      var url = "";

      switch (parseInt(category))
      {
        case 1:
          url = "/casi-clinici/show/" + slug;

          router.push(url);
          break;
        case 2:
          url = "/library/show/" + slug;
          router.push(url);
          break;
        case 3:
          httpauth
            .get("/meetings/check-meeting/" + slug)
            .then((response) => {
              if (response.data.status == 1)
              {
                if (
                  response.data.data.status == "programming" ||
                  response.data.data.status == "progress"
                )
                {
                  url = "/meeting/show/" + slug;
                } else if (response.data.data.status == "publish")
                {
                  url = "/meeting/registration/" + slug;
                }
                router.push(url);
              }
            })
            .catch((error) => {
              if (
                error.response.status == 401 &&
                error.response.data.message == "Unauthenticated."
              )
              {
                const auth = useAuth();
                auth.clearToken();
                url = "/";
              }
            });
          router.push(url);
          break;

        case 4:
          url = "/presentation/show/" + slug;
          router.push(url);
          break;
        case 5:
          url = "/forum/" + slug;
          router.push(url);
          break;
      }
    },
    onSwiper(swiper) {
      this.swiper = swiper;
    },
    changeSlide(index) {
      this.swiper.slideTo(index);
    },
  },
};
</script>

<style>
.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
<style scoped>
.border-2 {
  border: 3.5px solid red !important;
}

figure.product-media {
  height: 180px;
  overflow: hidden;
}

figure.product-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  max-height: none;
}

figure.product-media .embed-responsive {
  height: 100%;
}

/* Le locandine dei meeting sono verticali e contengono testo: vanno mostrate intere */
figure.product-media-poster {
  height: 260px;
}

figure.product-media-poster a,
figure.product-media-poster a>div,
figure.product-media-poster a>div>div {
  height: 100%;
}

figure.product-media-poster img {
  object-fit: contain;
  border: 0;
  padding: 0;
}

/* Ogni card occupa tutta l'altezza della slide e si struttura in colonna */
.swiper-slide>div {
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: left;
}

.product-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 8px;
}

/* Clamp del titolo a 2 righe per evitare altezze diverse */
.product-title>a {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 13px;
  line-height: 1.4;
}

.product-cat a {
  font-size: 12px;
}
</style>